import { render, staticRenderFns } from "./report_whole.vue?vue&type=template&id=dba63ef2&scoped=true&"
import script from "./report_whole.vue?vue&type=script&lang=js&"
export * from "./report_whole.vue?vue&type=script&lang=js&"
import style0 from "./report_whole.vue?vue&type=style&index=0&id=dba63ef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba63ef2",
  null
  
)

export default component.exports